import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { FaChild, FaHeart, FaMoneyBillWave } from "react-icons/fa";

function DecesCondPart(props) {
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            {context.state.TypeSimulation === "Audit prévoyance" || props.Statut === "TNS Article 62" || props.Statut === "TNS individuel" ? (
              <>
                <Row>
                  <Column>
                    <TextField
                      label="Capital décès toutes causes"
                      value={context.state.DecesTouteCause}
                      onKeyUp={context.handleMontantToTaux("DecesTouteCause")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Capital décès accidentel"
                      value={context.state.DecesAccidentel}
                      onKeyUp={context.handleMontantToTaux("DecesAccidentel")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Double effet"
                      value={context.state.DecesDoubleEffet}
                      onChange={context.handleInputChange("DecesDoubleEffet")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Frais d'obsèques"
                      value={context.state.FraisObseque}
                      onChange={context.handleInputChange("FraisObseque")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Rente conjoint annuelle"
                      value={context.state.RenteConjoint}
                      onKeyUp={context.handleMontantToTaux("RenteConjoint")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <div className="prise-en-charge-container prise-en-charge-table-container">
                    <table className="mono">
                      <tbody>
                        <tr>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Age de début
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Age de fin
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Rente éducation annuelle
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.DecesAgeDebut1}
                              onChange={context.handleInputChange("DecesAgeDebut1")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " ans" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.DecesAgeFin1} onChange={context.handleInputChange("DecesAgeFin1")} dataType="uint" format={{ thousands: " ", unit: " ans" }} />
                          </td>
                          <td>
                            <TextField
                              value={context.state.RenteEducation0_11}
                              onChange={context.handleInputChange("RenteEducation0_11")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.DecesAgeDebut2}
                              onChange={context.handleInputChange("DecesAgeDebut2")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " ans" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.DecesAgeFin2} onChange={context.handleInputChange("DecesAgeFin2")} dataType="uint" format={{ thousands: " ", unit: " ans" }} />
                          </td>
                          <td>
                            <TextField
                              value={context.state.RenteEducation12_17}
                              onChange={context.handleInputChange("RenteEducation12_17")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.DecesAgeDebut3}
                              onChange={context.handleInputChange("DecesAgeDebut3")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " ans" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.DecesAgeFin3} onChange={context.handleInputChange("DecesAgeFin3")} dataType="uint" format={{ thousands: " ", unit: " ans" }} />
                          </td>
                          <td>
                            <TextField
                              value={context.state.RenteEducation18_25}
                              onChange={context.handleInputChange("RenteEducation18_25")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Row>
              </>
            ) : (              <>
                <Row>
                    <CardBoxHeader icon={<FaMoneyBillWave />}>
                    <span>Capital</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Assiette de calcul"
                      value={context.state.BaseDecesComplementaireSalarie}
                      onChange={context.handleInputChange("BaseDecesComplementaireSalarie")}
                      options={[
                        { value: "SalaireBrut", label: "Salaire brut" },
                        { value: "SalaireNet", label: "Salaire net" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                <Row >
                  <Column>
                    <TextField
                      label="Capital décès toutes causes"
                      value={context.state.PourcentageDecesTouteCause}
                      onChange={context.handleInputChange("PourcentageDecesTouteCause")}
                      dataType="ufloat"
                      format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Capital décès accidentel"
                      value={context.state.PourcentageDecesAccidentel}
                      onChange={context.handleInputChange("PourcentageDecesAccidentel")}
                      dataType="ufloat"
                      format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Double effet"
                      value={context.state.DecesDoubleEffet}
                      onChange={context.handleInputChange("DecesDoubleEffet")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Frais d'obsèques"
                      value={context.state.FraisObseque}
                      onChange={context.handleInputChange("FraisObseque")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <CardBoxHeader icon={<FaHeart />}>
                    <span>Rente conjoint</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Assiette de calcul"
                      value={context.state.BaseRenteConjointComplementaireSalarie}
                      onChange={context.handleInputChange("BaseRenteConjointComplementaireSalarie")}
                      options={[
                        { value: "SalaireBrut", label: "Salaire brut" },
                        { value: "SalaireNet", label: "Salaire net" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                <Row >
                  <Column>
                    <TextField
                      label="Taux"
                      value={context.state.PourcentageRenteConjoint}
                      onChange={context.handleInputChange("PourcentageRenteConjoint")}
                      dataType="ufloat"
                      format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <CardBoxHeader icon={<FaChild />}>
                    <span>Rente éducation</span>
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Assiette de calcul"
                      value={context.state.BaseRenteEducationComplementaireSalarie}
                      onChange={context.handleInputChange("BaseRenteEducationComplementaireSalarie")}
                      options={[
                        { value: "SalaireBrut", label: "Salaire brut" },
                        { value: "SalaireNet", label: "Salaire net" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <div className="prise-en-charge-container prise-en-charge-table-container">
                    <table className="mono">
                      <tbody>
                        <tr>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Age de début
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Age de fin
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Rente éducation annuelle
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.DecesAgeDebut1}
                              onChange={context.handleInputChange("DecesAgeDebut1")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " ans" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.DecesAgeFin1} onChange={context.handleInputChange("DecesAgeFin1")} dataType="uint" format={{ thousands: " ", unit: " ans" }} />
                          </td>
                          <td>
                            <TextField
                              value={context.state.PourcentageRenteEducation0_11}
                              onChange={context.handleInputChange("PourcentageRenteEducation0_11")}
                              dataType="ufloat"
                              format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.DecesAgeDebut2}
                              onChange={context.handleInputChange("DecesAgeDebut2")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " ans" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.DecesAgeFin2} onChange={context.handleInputChange("DecesAgeFin2")} dataType="uint" format={{ thousands: " ", unit: " ans" }} />
                          </td>
                          <td>
                            <TextField
                              value={context.state.PourcentageRenteEducation12_17}
                              onChange={context.handleInputChange("PourcentageRenteEducation12_17")}
                              dataType="ufloat"
                              format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.DecesAgeDebut3}
                              onChange={context.handleInputChange("DecesAgeDebut3")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " ans" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.DecesAgeFin3} onChange={context.handleInputChange("DecesAgeFin3")} dataType="uint" format={{ thousands: " ", unit: " ans" }} />
                          </td>
                          <td>
                            <TextField
                              value={context.state.PourcentageRenteEducation18_25}
                              onChange={context.handleInputChange("PourcentageRenteEducation18_25")}
                              dataType="ufloat"
                              format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Row>
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default DecesCondPart;
